import script from "./quick-replies.vue?vue&type=script&lang=ts&setup=true"
export * from "./quick-replies.vue?vue&type=script&lang=ts&setup=true"

import "./quick-replies.vue?vue&type=style&index=0&id=60943fc5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60943fc5"]])

export default __exports__